import supportServiceDataApi from '@/api/supportServiceData';

export default {
  actions: {
    async getVehicleMarks() {
      try {
        const response = await supportServiceDataApi.getVehicleMarks();
        return response;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
